<script setup>
import ECommerceModulesForm from '@frontJs/components/forms/projectManagement/dev/ECommerceModulesForm.vue';
import ECommerceModulesTable from '@frontJs/components/tables/projectManagement/dev/ECommerceModulesTable.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import TabLayout from '@js/components/tabs/TabLayout.vue';
import PageTitle from '@js/components/titles/PageTitle.vue';
import { h } from 'vue';

const { tenant } = defineProps({
    tenant: {
        type: Object,
        required: false,
    },
});

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head v-if="tenant">
        <title>
            Mettre à jour les modules e-commerce - DEV - Gestion de projet -
            Datakepler
        </title>
    </Head>

    <Head v-else>
        <title>Modules e-commerce - DEV - Gestion de projet - Datakepler</title>
    </Head>

    <PageTitle v-if="tenant" :tenant-name="tenant.name">
        Gestion de projet - DEV - Mettre à jour les modules e-commerce
    </PageTitle>

    <PageTitle v-else> Gestion de projet - DEV - Modules e-commerce </PageTitle>

    <ECommerceModulesForm v-if="tenant" :tenant="tenant" />

    <TabLayout
        v-else
        :tabs="{
            all: {
                title: 'Tous',
                content: h(ECommerceModulesTable),
            },
            shipping: {
                title: 'Livraison',
                content: h(ECommerceModulesTable, { type: 'shipping' }),
            },
            payment: {
                title: 'Paiement',
                content: h(ECommerceModulesTable, { type: 'payment' }),
            },
            review: {
                title: 'Avis',
                content: h(ECommerceModulesTable, { type: 'review' }),
            },
            search: {
                title: 'Recherche',
                content: h(ECommerceModulesTable, { type: 'search' }),
            },
            checkout: {
                title: 'Checkout',
                content: h(ECommerceModulesTable, { type: 'checkout' }),
            },
        }"
    />
</template>
